import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page36() {
  useEffect(() => {
    document.title = "Маяк — Страница 35"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page34" />
        <ForwardLink href="/page36" />
      </div>

      <p style={{ textAlign: "right" }}>35.</p>
      <p>
        – МОЛОДОЙ чистит часовой механизм, наклонившись в странной позе.<br/>
        Его <u>МЕШОЧЕК ДЛЯ ТАБАКА падает на землю</u>.
      </p>
      <p>– <u>СТАРИК заходит в ФОНАРНОЕ ОТДЕЛЕНИЕ и ЗАПИРАЕТ ЕГО.</u></p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – НОЧЬ</p>
      <p>МОЛОДОЙ ворочается в постели. Беспокойный. Разгоряченный. Потный.</p>
      <p>Звук волн, разбивающихся о берег, неумолим.</p>
      <p>ЧАСЫ монотонно тикают.</p>
      <p>Он пытается найти прохладное место на кровати.</p>
      <p>
        Переворачивает подушку... сбрасывает с себя постельное белье как
        рассерженный малыш...
      </p>
      <p>
        Он в одном нижнем белье. Вырезанная РУСАЛКА лежит на кровати
        рядом с ним.
      </p>
      <p>
        (На стене позади него приколоты вырезки желаемых<br/>
        товаров из каталога «Сирс и Робак», программа<br/>
        мюзик-холла «Тендерлойн»  и несколько порнографических игральных карт.)
      </p>
      <p>
        Сбрасывание белья не помогает. Он садится. Закладывает<br/>
        руку за ухо... сигареты нет.
      </p>
      <p>Он лезет в карман рубашки, висящей в изножье перекладины кровати...</p>
      <p>КИСЕТА ДЛЯ ТАБАКА там нет.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Дерьмо.
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – НОЧЬ</p>
      <p>МУЗЫКАЛЬНАЯ ВСТАВКА: Жуткая “легкая” музыка.</p>
      <p>
        МОЛОДОЙ видит МЕШОЧЕК, лежащий поверх вращающегося<br/>
        часового механизма. Он хватает его и быстро начинает спускаться вниз<br/>
        по лестнице, но...
      </p>
      <p>Что-то останавливает его.</p>
      <p>Чувство. Вопрос.</p>
      <p>
        Часовой механизм вращается, свет отражается на его медной поверхности,<br/>
        море и ветер поют свою ритмичную песню.
      </p>
      <p style={{ textAlign: "right" }}>35.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page34" />
        <ForwardLink href="/page36" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710021130/the-lighthouse-script/idopw7rf3kapkcrwe40m.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page36;
